import * as Yup from 'yup'
import { parsePhoneNumber } from 'react-phone-number-input'
import { Formik } from 'formik'
import { Button, Col, Form, FormControl, Row } from 'react-bootstrap'
import React from 'react'

const EnterMobileNumberForm = ({onComplete,labelText='Mobile number', disabled = false}) => {
  const schema = Yup.object().shape({
    phone: Yup.string().required("Mobile number is required").test("anotherOne", "Mobile number is not valid", (numberToValidate) => {
      // if nothing is set
      if (!numberToValidate)
        return false;

      const phoneNumber = parsePhoneNumber(numberToValidate, "GB");
      if (phoneNumber) {

        //its definitely not mobile "MOBILE" or maybe "FIXED_LINE_OR_MOBILE"
        // we should just reject all the numbers we have a definite type
        if (phoneNumber.getType() === "FIXED_LINE") {
          return false;
        }

        return phoneNumber.isValid();
      }

      return false;

    })
  });
  

  return <Formik
    enableReinitialize
    validationSchema={schema}
    initialValues={{ phone: '' }}
   onSubmit={(values)=>{ onComplete(values.phone); }}>
    {({
      handleSubmit,
      handleChange,
      handleBlur,
      values,
      touched,
      isValid,
      errors
    }) => (
      <Form
        noValidate
        onSubmit={handleSubmit}
        id="onlineAccessForm"
        autoComplete="off"
      >
        <React.Fragment>
          <Row className={"mb-4"}>
            <Col>
              <p className={"mb-0"}>
                Please enter your mobile number below to receive your verification code.
              </p>
            </Col>
          </Row>
          <Form.Row className={"mb-4"}>
            <Form.Group
              as={Col}
              controlId="validationPhone"
              className="material material label-top mb-0"
            >
              <FormControl
                type="tel"
                name="phone"
                value={values.phone}
                onChange={handleChange}
                isInvalid={
                  touched.phone && errors.phone
                }
                disabled={
                  disabled
                }
              />
              <Form.Label>{labelText}</Form.Label>
              <Form.Control.Feedback type="invalid">
                {errors.phone}
              </Form.Control.Feedback>
            </Form.Group>
          </Form.Row>
          <Row className={"mb-4"}>
            <Col className={`text-center`}>
              <Button
                type="submit"
                variant="primary"
                className="btn-wide"
                disabled={disabled }
              >
                Next
              </Button>
            </Col>
          </Row>
        </React.Fragment>
      </Form>
    )}
  </Formik>;
};

export default EnterMobileNumberForm;